import { useEffect, useState } from "react";

declare global {
	interface Window {
		isFlexApp?: boolean;
		flexAppPlatform?: string;
		flexAppVersion?: string;
		flexAppInsets?: {
			top: number;
			bottom: number;
			left: number;
			right: number;
		};
	}
}

function getCookie(name: string): string | null {
	const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
	return match ? match[2] : null;
}

/**
 * Detects if running inside the Amber Flex native app shell.
 * Reads from two sources (whichever is truthy first):
 * 1. window.isFlexApp — injected by native before React renders
 * 2. is_flex_app cookie — seeded by native before first request
 */
const useIsFlexApp = () => {
	const [isFlexApp, setIsFlexApp] = useState(() => {
		if (typeof window === "undefined") return false;
		return Boolean(window.isFlexApp) || getCookie("is_flex_app") === "true";
	});

	useEffect(() => {
		if (window.isFlexApp || getCookie("is_flex_app") === "true") {
			setIsFlexApp(true);
		}
	}, []);

	return isFlexApp;
};

export const isFlexApp = () =>
	typeof window !== "undefined" &&
	(Boolean(window.isFlexApp) || getCookie("is_flex_app") === "true");

export const flexAppPlatform = (): string =>
	typeof window !== "undefined" ? window.flexAppPlatform || "" : "";

export const flexAppVersion = (): string =>
	typeof window !== "undefined" ? window.flexAppVersion || "" : "";

export const flexAppInsets = () =>
	typeof window !== "undefined" ? window.flexAppInsets || null : null;

export default useIsFlexApp;
